import { Flex, Modal, Button } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import { CustomTitle } from "../customTitle";
import { Worker, Viewer, ScrollMode } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import {
  acceptTermsAndConditionsAction,
  getTermsAndConditionsAction,
} from "../../../redux/services/common/commonServices";

import useLocalStorage from "../../../hooks/useLocalStorage";
import { appConfig } from "../../../constants/config/appConfig";

const TermsAndConditionsDialog = ({
  open,
  onClose,
  showAcceptButton = true,
  closable = false
}) => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  const { setUserSession } = useLocalStorage(appConfig.SESSION_USER_INFO);

  /* terms and condition details */
  const { termsAndConditionsUrl } = useSelector((state) => state.common);
  /* terms and condition details */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);

  /* initial dependencies */
  useEffect(() => {
    dispatch(getTermsAndConditionsAction(setLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /* initial dependencies */

  /* function definition to accept terms and conditions */
  const handleAcceptTermsAndConditions = () => {
    dispatch(acceptTermsAndConditionsAction(setLoading, setUserSession, onClose));
  };
  /* function definition to accept terms and conditions */

  return (
    <Modal
      open={(termsAndConditionsUrl &&
        termsAndConditionsUrl !== null &&
        termsAndConditionsUrl !== "" &&
        termsAndConditionsUrl !== undefined) ? open : false}
      footer={false}
      closable={closable}
      confirmLoading={loading}
      width={800}
      onCancel={()=>closable && onClose()}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {t("termsCondition.Terms&Conditions")}
        </CustomTitle>
          {/* Use the same version for the worker as the main library */}
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            {termsAndConditionsUrl &&
              termsAndConditionsUrl !== null &&
              termsAndConditionsUrl !== "" &&
              termsAndConditionsUrl !== undefined && (
                <Viewer fileUrl={termsAndConditionsUrl} />
              )}
          </Worker>
        {showAcceptButton && (
          <Button
            size="middle"
            type="primary"
            onClick={() => handleAcceptTermsAndConditions()}
          >
            {t("CommonUtils.accept")}
          </Button>
        )}
      </Flex>
    </Modal>
  );
};

export default TermsAndConditionsDialog;
